/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_MarcaCarga as MarcaCarga,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_hr as hr,
  rec_vr as vr,
} from "../../runtime/index.jsx";
export function FiltroColumna(e) {
  let t = (0, ReactCompiler.c)(58),
    { valores: n, permitidos: r, onOrdenar: i, onFiltrar: a, titulo: o } = e,
    [s, c] = (0, React.useState)(``),
    l;
  if (t[0] !== s || t[1] !== n) {
    let e = s.trim().toLowerCase();
    ((l = e ? n.filter((t) => t.toLowerCase().includes(e)) : n),
      (t[0] = s),
      (t[1] = n),
      (t[2] = l));
  } else l = t[2];
  let u = l,
    f;
  t[3] === r
    ? (f = t[4])
    : ((f = (e) => !r || r.has(e)), (t[3] = r), (t[4] = f));
  let p = f,
    m;
  t[5] !== u || t[6] !== p
    ? ((m = u.every(p)), (t[5] = u), (t[6] = p), (t[7] = m))
    : (m = t[7]);
  let h = m,
    _;
  t[8] !== a || t[9] !== r || t[10] !== n
    ? ((_ = function (e, t) {
        let i = new Set(r ?? n);
        (t ? i.add(e) : i.delete(e), a(n.every((e) => i.has(e)) ? null : i));
      }),
      (t[8] = a),
      (t[9] = r),
      (t[10] = n),
      (t[11] = _))
    : (_ = t[11]);
  let v = _,
    y;
  t[12] !== u || t[13] !== a || t[14] !== r || t[15] !== n
    ? ((y = function (e) {
        let t = new Set(r ?? n);
        for (let n of u) e ? t.add(n) : t.delete(n);
        a(n.every((e) => t.has(e)) ? null : t);
      }),
      (t[12] = u),
      (t[13] = a),
      (t[14] = r),
      (t[15] = n),
      (t[16] = y))
    : (y = t[16]);
  let b = y,
    x;
  t[17] === i ? (x = t[18]) : ((x = () => i(`asc`)), (t[17] = i), (t[18] = x));
  let S;
  t[19] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((S = (0, JSXRuntime.jsx)(hr, {
        className: `h-4 w-4`,
      })),
      (t[19] = S))
    : (S = t[19]);
  let C;
  t[20] === x
    ? (C = t[21])
    : ((C = (
        <button
          type={`button`}
          onClick={x}
          className={`flex items-center gap-2 rounded-lg px-2 py-1.5 text-left hover:bg-(--accent-bg)`}
          children={[S, ` Ordenar de A a Z`]}
        />
      )),
      (t[20] = x),
      (t[21] = C));
  let w;
  t[22] === i ? (w = t[23]) : ((w = () => i(`desc`)), (t[22] = i), (t[23] = w));
  let T;
  t[24] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((T = (0, JSXRuntime.jsx)(vr, {
        className: `h-4 w-4`,
      })),
      (t[24] = T))
    : (T = t[24]);
  let E;
  t[25] === w
    ? (E = t[26])
    : ((E = (
        <button
          type={`button`}
          onClick={w}
          className={`flex items-center gap-2 rounded-lg px-2 py-1.5 text-left hover:bg-(--accent-bg)`}
          children={[T, ` Ordenar de Z a A`]}
        />
      )),
      (t[25] = w),
      (t[26] = E));
  let D;
  t[27] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((D = <div className={`my-1 border-t border-(--border)`} />), (t[27] = D))
    : (D = t[27]);
  let O = `Buscar en ${o}`,
    k;
  t[28] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((k = (e) => c(e.target.value)), (t[28] = k))
    : (k = t[28]);
  let A;
  t[29] !== s || t[30] !== O
    ? ((A = (
        <input
          aria-label={O}
          value={s}
          onChange={k}
          placeholder={`Buscar`}
          className={`rounded-lg border border-(--border) bg-(--bg) px-2 py-1 text-sm outline-none focus:ring-2 focus:ring-(--accent-bg)`}
        />
      )),
      (t[29] = s),
      (t[30] = O),
      (t[31] = A))
    : (A = t[31]);
  let j;
  t[32] !== b || t[33] !== h
    ? ((j = (
        <MarcaCarga checked={h} onChange={b} children={`(Seleccionar todo)`} />
      )),
      (t[32] = b),
      (t[33] = h),
      (t[34] = j))
    : (j = t[34]);
  let M;
  if (t[35] !== v || t[36] !== u || t[37] !== p) {
    let e;
    (t[39] !== v || t[40] !== p
      ? ((e = (e) => (
          <MarcaCarga
            key={e || `(vacías)`}
            className={`mt-1`}
            checked={p(e)}
            onChange={(t) => v(e, t)}
            children={e || `(Vacías)`}
          />
        )),
        (t[39] = v),
        (t[40] = p),
        (t[41] = e))
      : (e = t[41]),
      (M = u.map(e)),
      (t[35] = v),
      (t[36] = u),
      (t[37] = p),
      (t[38] = M));
  } else M = t[38];
  let N;
  t[42] === u.length
    ? (N = t[43])
    : ((N = !u.length && (
        <p
          className={`py-2 text-xs text-(--text)`}
          children={`Nada coincide`}
        />
      )),
      (t[42] = u.length),
      (t[43] = N));
  let P;
  t[44] !== j || t[45] !== M || t[46] !== N
    ? ((P = (
        <div className={`max-h-60 overflow-y-auto px-1`} children={[j, M, N]} />
      )),
      (t[44] = j),
      (t[45] = M),
      (t[46] = N),
      (t[47] = P))
    : (P = t[47]);
  let F;
  t[48] !== a || t[49] !== r || t[50] !== o
    ? ((F = r && (
        <button
          type={`button`}
          onClick={() => a(null)}
          className={`mt-1 rounded-lg px-2 py-1.5 text-left text-(--accent) hover:bg-(--accent-bg)`}
          children={[`Quitar filtro de `, o]}
        />
      )),
      (t[48] = a),
      (t[49] = r),
      (t[50] = o),
      (t[51] = F))
    : (F = t[51]);
  let I;
  return (
    t[52] !== E || t[53] !== A || t[54] !== P || t[55] !== F || t[56] !== C
      ? ((I = (
          <div
            className={`flex flex-col gap-1 text-sm text-(--text-h)`}
            children={[C, E, D, A, P, F]}
          />
        )),
        (t[52] = E),
        (t[53] = A),
        (t[54] = P),
        (t[55] = F),
        (t[56] = C),
        (t[57] = I))
      : (I = t[57]),
    I
  );
}
